/**
 * API Configuration
 */

// Base host — no trailing slash
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Versioned API base — used for all /api/v1/... requests
export const API_V1_URL = `${API_BASE_URL}/api/v1`;

export const API_ENDPOINTS = {
  // ── Auth ───────────────────────────────────────────
  REGISTER:     '/api/v1/auth/register',
  LOGIN:        '/api/v1/auth/login',
  ME:           '/api/v1/auth/me',

  // ── Submissions ────────────────────────────────────
  SUBMISSIONS:           '/api/v1/submissions',
  SUBMISSION_DETAIL:     (id) => `/api/v1/submissions/${id}`,

  // ── Wallet ─────────────────────────────────────────
  WALLET_BALANCE:        '/api/v1/wallet/balance',
  WALLET_TRANSACTIONS:   '/api/v1/wallet/transactions',
  WALLET_PACKS:          '/api/v1/wallet/packs',
  WALLET_PURCHASE:       '/api/v1/wallet/purchase',
  WALLET_VERIFY:         '/api/v1/wallet/verify',

  // ── Admin — Orgs ───────────────────────────────────
  ADMIN_ORGS:            '/api/v1/admin/orgs',
  ADMIN_ORG:             (id) => `/api/v1/admin/orgs/${id}`,
  ADMIN_ORG_CODES:       (id) => `/api/v1/admin/orgs/${id}/codes`,
  ADMIN_ORG_CODE:        (orgId, codeId) => `/api/v1/admin/orgs/${orgId}/codes/${codeId}`,
  ADMIN_ORG_CREDITS:     (id) => `/api/v1/admin/orgs/${id}/credits`,
  ADMIN_ORG_USAGE:       (id) => `/api/v1/admin/orgs/${id}/usage`,

  // ── Admin — Stats & Users ──────────────────────────
  ADMIN_USERS:           '/api/v1/admin/users',
  ADMIN_SUBMISSIONS:     '/api/v1/admin/submissions',
  ADMIN_STATS_LLM:       '/api/v1/admin/stats/llm-usage',
  ADMIN_STATS_SUBS:      '/api/v1/admin/stats/submissions',

  // ── Health ─────────────────────────────────────────
  HEALTH:                '/api/v1/health',
};

export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER:  'user',
};

